var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpposition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.894,9.641c-10.182,0-18.465,8.283-18.465,18.465c0,3.65,1.078,7.047,2.913,9.915L38.02,56.342  c-2.868-1.834-6.264-2.913-9.914-2.913c-10.182,0-18.465,8.283-18.465,18.464c0,10.182,8.283,18.465,18.465,18.465  s18.465-8.283,18.465-18.465c0-4.367-1.532-8.378-4.076-11.543l17.855-17.855c3.165,2.543,7.176,4.075,11.542,4.075  c10.182,0,18.465-8.283,18.465-18.465S82.075,9.641,71.894,9.641z M28.106,84.358c-6.873,0-12.465-5.592-12.465-12.465  S21.233,59.43,28.106,59.43s12.465,5.591,12.465,12.464S34.979,84.358,28.106,84.358z M71.894,40.571  c-6.873,0-12.465-5.592-12.465-12.465s5.592-12.465,12.465-12.465s12.465,5.592,12.465,12.465S78.767,40.571,71.894,40.571z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpposition);
export default __webpack_public_path__ + "static/media/opposition.49c11acaa4992967314b0938ac2efed6.svg";
export { ForwardRef as ReactComponent };